import { render, staticRenderFns } from "./templateOne.vue?vue&type=template&id=966c9348&scoped=true&"
import script from "./templateOne.vue?vue&type=script&lang=js&"
export * from "./templateOne.vue?vue&type=script&lang=js&"
import style0 from "./templateOne.vue?vue&type=style&index=0&id=966c9348&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../cache/node/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "966c9348",
  null
  
)

export default component.exports